/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MainContextSection } from './MainContextSection';
import {
    MainContextSectionFromJSON,
    MainContextSectionFromJSONTyped,
    MainContextSectionToJSON,
} from './MainContextSection';

/**
 * 
 * @export
 * @interface TenantMainContext
 */
export interface TenantMainContext {
    /**
     * Fixed literal 'main' — one record per tenant.
     * @type {string}
     * @memberof TenantMainContext
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantMainContext
     */
    tenant_id?: string;
    /**
     * Ordered tenant-owned clinic-facts sections. Behavioural prompt text stays code-owned.
     * @type {Array<MainContextSection>}
     * @memberof TenantMainContext
     */
    sections?: Array<MainContextSection>;
    /**
     * 
     * @type {number}
     * @memberof TenantMainContext
     */
    updated_at?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantMainContext
     */
    updated_by?: string;
}

/**
 * Check if a given object implements the TenantMainContext interface.
 */
export function instanceOfTenantMainContext(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantMainContextFromJSON(json: any): TenantMainContext {
    return TenantMainContextFromJSONTyped(json, false);
}

export function TenantMainContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantMainContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'sections': !exists(json, 'sections') ? undefined : ((json['sections'] as Array<any>).map(MainContextSectionFromJSON)),
        'updated_at': !exists(json, 'updated_at') ? undefined : json['updated_at'],
        'updated_by': !exists(json, 'updated_by') ? undefined : json['updated_by'],
    };
}

export function TenantMainContextToJSON(value?: TenantMainContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'sections': value.sections === undefined ? undefined : ((value.sections as Array<any>).map(MainContextSectionToJSON)),
        'updated_at': value.updated_at,
        'updated_by': value.updated_by,
    };
}

